import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import './index.scss';
import {
    ButtonPrimary,
    ErrorFeedbackScreen,
    SuccessFeedbackScreen,
    skinVars,
    useWindowSize,
} from '@telefonica/mistica';
import { useLocation, useNavigate } from 'react-router-dom';
import ContactInfoVerificationStep1 from '../../contactInfoVerificationStep1';
import { TrackingEvents } from '../../../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../../../utils/navigation/controlDevices';

export interface FeedbackOTPData {
    fromDesktop?: boolean;
    setComponentSelected?: any;
    errDesktop?: any;
    stateFeedbackDesktop?: any;
}

export const FeedbackOTP: React.FC<FeedbackOTPData> = ({
    fromDesktop,
    setComponentSelected,
    errDesktop,
    stateFeedbackDesktop,
}: FeedbackOTPData) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { trackingScreenView } = new TrackingEvents();
    const err = fromDesktop ? errDesktop : state?.err;
    const stateFeedback = fromDesktop ? stateFeedbackDesktop : state?.stateFeedback;
    const size = useWindowSize();

    const sendToNative = (url: string, title?: string) => {
        if (fromDesktop) {
            setComponentSelected(
                <ContactInfoVerificationStep1
                    fromDesktop={true}
                    setComponentSelected={setComponentSelected}
                ></ContactInfoVerificationStep1>,
            );
        } else {
            navigate(url);
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <div
            className='feedbackOTP-page'
            style={{
                background:
                    stateFeedback === 'SUCCESS'
                        ? size.width < 1024 || size.height < 550
                            ? skinVars.colors.backgroundBrand
                            : ''
                        : skinVars.colors.background,
            }}
        >
            {stateFeedback === 'SUCCESS' ? (
                <SuccessFeedbackScreen
                    title={t('contactVerificationSuccessTitle')}
                    description={t('contactVerificationSuccessSubtitle')}
                    primaryButton={
                        <ButtonPrimary
                            onPress={() => {
                                sendToNative('/obd/verify/contacts', 'Verificar datos de contacto');
                            }}
                        >
                            {t('buttonUnderstoodFeedback')}
                        </ButtonPrimary>
                    }
                ></SuccessFeedbackScreen>
            ) : (
                <ErrorFeedbackScreen
                    title={err.title}
                    description={err.localizedDescription}
                    errorReference={'Código de error: ' + `${err.id}`}
                    primaryButton={
                        <ButtonPrimary
                            onPress={() => {
                                sendToNative('/obd/verify/contacts', 'Verificar datos de contacto');
                            }}
                        >
                            {t('buttonUnderstoodFeedback')}
                        </ButtonPrimary>
                    }
                ></ErrorFeedbackScreen>
            )}
        </div>
    );
};

export default FeedbackOTP;
